import React, { useState } from "react";
import { PlusCircle, History } from "lucide-react";
import EntryForm from "./VisitEntry";
import VisitHistory from "./VisitHistory";

const VisitManager = () => {
  const [activeTab, setActiveTab] = useState("form");
  const [history, setHistory] = useState([]);

  // Shared state for editing
  const [editingItem, setEditingItem] = useState(null);

  const addEntry = (newEntry) => {
    setHistory([newEntry, ...history]);
    setActiveTab("history");
  };

  const updateEntry = (updatedEntry) => {
    setHistory(
      history.map((item) =>
        item.id === updatedEntry.id ? updatedEntry : item,
      ),
    );
    setEditingItem(null);
    setActiveTab("history");
  };

  return (
    <div className=" bg-gray-50/50 p-4 ">
      <div className="mx-auto flex items-center justify-between mb-3">
        <div className="mb-4">
          <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight">
            Visit Check-in
          </h1>
          <p className="text-slate-500 mt-1">
            Record field visits and customer interactions in real-time.
          </p>
        </div>
        <div className="flex bg-white p-1 rounded-2xl shadow-sm border border-slate-200 w-fit mb-8">
          <button
            onClick={() => setActiveTab("form")}
            className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold transition-all ${activeTab === "form" ? "bg-blue-600 text-white shadow-md" : "text-slate-500"}`}
          >
            <PlusCircle className="w-4 h-4" />{" "}
            {editingItem ? "Edit Entry" : "New Entry"}
          </button>
          <button
            onClick={() => setActiveTab("history")}
            className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold transition-all ${activeTab === "history" ? "bg-blue-600 text-white shadow-md" : "text-slate-500"}`}
          >
            <History className="w-4 h-4" /> My Entries
          </button>
        </div>
      </div>
      {activeTab === "form" ? (
        <EntryForm
          onSave={editingItem ? updateEntry : addEntry}
          initialData={editingItem}
        />
      ) : (
        <VisitHistory
          data={history}
          onDelete={(id) => setHistory(history.filter((h) => h.id !== id))}
          onEdit={(item) => {
            setEditingItem(item);
            setActiveTab("form");
          }}
        />
      )}
    </div>
  );
};

export default VisitManager;
